import { useLayoutEffect } from "react";

export function useLayoutHeightVars() {
    useLayoutEffect(() => {
        let header = null;
        let footer = null;
        const resizeObserver = new ResizeObserver(() => update());

        const readCssPx = (name) => {
            const value = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
            const parsed = parseFloat(value);
            return Number.isFinite(parsed) ? parsed : 0;
        };

        const update = () => {
            const h = Math.round(header?.getBoundingClientRect().height ?? readCssPx("--header-height"));
            const f = Math.round(footer?.getBoundingClientRect().height ?? readCssPx("--footer-height"));

            document.documentElement.style.setProperty("--header-height", `${h}px`);
            document.documentElement.style.setProperty("--footer-height", `${f}px`);
            // --page-height — remaining space between header and footer (100dvh - header - footer)
            document.documentElement.style.setProperty("--page-height", `calc(100dvh - ${h}px - ${f}px)`);
        };

        const connectObservers = () => {
            const nextHeader = document.getElementById("app-header");
            const nextFooter = document.getElementById("app-footer");

            if (nextHeader !== header) {
                if (header) resizeObserver.unobserve(header);
                header = nextHeader;
                if (header) resizeObserver.observe(header);
            }

            if (nextFooter !== footer) {
                if (footer) resizeObserver.unobserve(footer);
                footer = nextFooter;
                if (footer) resizeObserver.observe(footer);
            }

            if (header || footer) update();
        };

        connectObservers();

        const mutationObserver = new MutationObserver(connectObservers);
        mutationObserver.observe(document.body, { childList: true, subtree: true });

        const onWindowResize = () => update();
        window.addEventListener("resize", onWindowResize);

        return () => {
            mutationObserver.disconnect();
            resizeObserver.disconnect();
            window.removeEventListener("resize", onWindowResize);
        };
    }, []);
}
